import './CommentField.css';

const CommentField = ({ comment, setComment }) => {
  return (
    <div className='custom-textfield'>
      <p>Gostaria de deixar um comentário mais específico?</p>
      <textarea className='custom-textarea'
        value={comment}
        onChange={e => setComment(e.target.value)}
      />
    </div>
  );
};

export default CommentField;
